// extracted by mini-css-extract-plugin
export default {"root":"Success_root__Repwt","icon":"Success_icon__sjjUB"};